import { Operation } from "@/components/operation-button";

export function getOperationType(
  btn: HTMLDivElement
): Operation | string | undefined {
  return btn.dataset.type as Operation;
}
